import { fetchAuthSession } from '@aws-amplify/auth';

export const currentEnv = process.env.REACT_APP_ENV;
// console.log(currentEnv);

const envSettings = {
  local: {
    apiGateway: 'http://localhost:3010/api',
    userPoolId: 'ap-northeast-1_ySOKja14X',
    appClientId: '7ktsm6rvf76s2mbgqo63506uhg',
    identityPoolId: '',
    gaTrackingId: 'UA-156966715-1',
  },
  development: {
    apiGateway: 'https://app.timss-dev.toyota-tsusho.com/api',
    userPoolId: 'ap-northeast-1_ySOKja14X',
    appClientId: '7ktsm6rvf76s2mbgqo63506uhg',
    identityPoolId: '',
    gaTrackingId: 'UA-156966715-1',
  },
  staging: {
    apiGateway: 'https://app.timss-qas.toyota-tsusho.com/api',
    userPoolId: 'ap-northeast-1_rnnFGMQy4',
    appClientId: '2r709j7k9m19uqcph9bjokvk4p',
    identityPoolId: '',
    gaTrackingId: 'UA-164006703-1',
  },
  production: {
    apiGateway: 'https://app.timss.toyota-tsusho.com/api',
    userPoolId: 'ap-northeast-1_ezrhADWdv',
    appClientId: '3j1f0qlto77ock98n5e3semr93',
    identityPoolId: '',
    gaTrackingId: 'UA-164045198-1',
  },
};

export default {
  s3: {
    REGION: 'ap-northeast-1',
    BUCKET: 'wms-server-uploads',
  },
  apiGateway: {
    NAME: 'millSheetAPIGateway',
    REGION: 'ap-northeast-1',
    URL: envSettings[currentEnv]?.apiGateway ?? envSettings.development.apiGateway,
    custom_header: async () => {
      const authSession = await fetchAuthSession();
      const token = authSession?.tokens?.idToken?.toString();
      if (token) {
        return { Authorization: 'Bearer ' + token };
      } else {
        return {};
      }
    },
  },
  cognito: {
    REGION: 'ap-northeast-1',
    USER_POOL_ID: envSettings[currentEnv]?.userPoolId ?? envSettings.development.userPoolId,
    APP_CLIENT_ID: envSettings[currentEnv]?.appClientId ?? envSettings.development.appClientId,
    IDENTITY_POOL_ID: envSettings[currentEnv]?.identityPoolId ?? envSettings.development.identityPoolId,
  },
  ga: {
    TRACKING_ID: envSettings[currentEnv]?.gaTrackingId ?? envSettings.development.gaTrackingId,
  },
};
